import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantAdditionalIncomePage = {
  alert: {
    error: 'coapplicant-additional-income-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-additional-income-page.footer.root',
  },
  form: {
    h1: 'coapplicant-additional-income-page.form.h1',
    h2: 'coapplicant-additional-income-page.form.h2',
    radioGroupRoot: 'coapplicant-additional-income-page.form.radio-group-root',
    radioOption1: 'coapplicant-additional-income-page.form.radio-option1',
    radioOption2: 'coapplicant-additional-income-page.form.radio-option2',
    root: 'coapplicant-additional-income-page.form.root',
    submitButton: 'coapplicant-additional-income-page.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-additional-income-page.header.drawer-button',
    previousStepButton:
      'coapplicant-additional-income-page.header.previous-step-button',
    root: 'coapplicant-additional-income-page.header.root',
  },
  progress: {
    root: 'coapplicant-additional-income-page.progress.root',
  },
} as const satisfies PageLocatorMap;
